import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import styles from './Skeleton.module.scss'

const Skeleton = props => {

  const {
    type,
    width,
    height,
    style
  } = props

  const elementStyle = {
    display: 'inline-block',
    width: '100%',
    height: 'auto',
    ...style
  }

  if (width != null) {
    elementStyle.width = width
  }

  if (height != null) {
    elementStyle.height = height
  }

  const elements = []
  for (let i = 0; i < props.count; i++) {
    elements.push(
      <span key={i} className={classNames(styles.skeleton, styles[type])} style={elementStyle}>
        &zwnj;
      </span>
    )
  }

  const Wrapper = props.wrapper
  return (
    <span className={styles.wrapper}>
      {Wrapper
        ? elements.map((element, i) => (
          <Wrapper key={i}>
            {element}
                &zwnj;
          </Wrapper>
        ))
        : elements}
    </span>
  )
}

Skeleton.propTypes = {
  type: PropTypes.string,
  style: PropTypes.object,
  count: PropTypes.number,
  height: PropTypes.string,
  width: PropTypes.string,
  wrapper: PropTypes.string
}

Skeleton.defaultProps = {
  type: 'lightest',
  style: null,
  count: 1,
  duration: 3,
  width: null,
  height: null,
  wrapper: null
}

export default Skeleton
